//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MobileHeader",
  props: {
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      keyword: "",
      logoImg: require("@/assets/newimg/logo.png"),
      searchIcon: require("@/assets/newimg/home_search.png"),
      defaultAvatar: require("@/assets/img/user.png")
    };
  },
  computed: {
    cssVars: function cssVars() {
      return {
        "--mh-spacing": "16px",
        "--mh-font-base": "14px",
        "--mh-text": "#1a1a2e",
        "--mh-text-tertiary": "#9ca3af",
        "--mh-primary": "#1668f4",
        "--mh-shadow": "0 1px 4px rgba(10, 61, 145, 0.08)",
        "--mh-inner-height": "56px",
        "--mh-inner-gap": "8px",
        "--mh-logo-height": "26px",
        "--mh-search-height": "36px",
        "--mh-search-radius": "18px",
        "--mh-search-padding-x": "14px",
        "--mh-search-gap": "8px",
        "--mh-search-icon-size": "18px",
        "--mh-input-font-size": "13px",
        "--mh-login-min-width": "36px",
        "--mh-avatar-size": "32px"
      };
    }
  },
  methods: {
    handleSearch: function handleSearch() {
      var kw = (this.keyword || "").trim();
      this.$emit("search", kw);
      this.keyword = "";
    },
    handleLogin: function handleLogin() {
      this.$emit("login");
    },
    goHome: function goHome() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    }
  }
};